module.exports = __webpack_public_path__ + "1d7360268f41913b634d6e7f077ba17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/App/assets/AppDownload@2x.png
// module id = 2002
// module chunks = 1